/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bronze_Teal_Mule_LeapInputs */

const en_bronze_teal_mule_leap = /** @type {(inputs: Bronze_Teal_Mule_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group`)
};

const de_bronze_teal_mule_leap = /** @type {(inputs: Bronze_Teal_Mule_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe`)
};

/**
* | output |
* | --- |
* | "Group" |
*
* @param {Bronze_Teal_Mule_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bronze_teal_mule_leap = /** @type {((inputs?: Bronze_Teal_Mule_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bronze_Teal_Mule_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bronze_teal_mule_leap(inputs)
	return de_bronze_teal_mule_leap(inputs)
});